// The product's one copy answer (the operator, 2026-08-30: "everywhere";
// r9x-5: "we have a standard — keep it, the same everywhere, not at random").
// A press copies; once the text is on the clipboard the pixel toast says what
// was copied. The mark itself never changes: no green, no check.

import { CopyIcon } from '@phosphor-icons/react'
import { useCallback } from 'react'
import { useOptionalPixelToast } from './pixel-toast'

/** `copy(text, content)`: writes `text`, then toasts `content` (e.g.
 *  "Wallet address copied"). A write that fails says nothing. Resolves
 *  whether the text is on the clipboard — for a modal dialog, whose outside
 *  (the toast's stack) a screen reader is not told about, to say it inside. */
export function useCopyToast(): (text: string, content: string) => Promise<boolean> {
  const toast = useOptionalPixelToast()
  return useCallback(
    (text: string, content: string) => {
      if (!navigator.clipboard) return Promise.resolve(false)
      return navigator.clipboard.writeText(text).then(
        () => {
          toast?.push({
            tone: 'ok',
            content,
            icon: <CopyIcon size={15} weight="bold" />,
            close: true,
          })
          return true
        },
        () => false
      )
    },
    [toast]
  )
}
